import wx from 'weixin-js-sdk';
import API from '@/api';

const WX: any = wx; //微信
const wxPromisify: any = {}; //自定义微信
let _wxReadyPromisify: any = null; //微信实例

//微信sdk方法
const wxConfigList: any = [
  //新版分享
  'updateTimelineShareData',
  'updateAppMessageShareData',
  // 旧版本分享 即将废弃
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',

  'hideOptionMenu',
  'showOptionMenu',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem',
  'closeWindow',
];

//微信sdk方法
const syncApiList = [...wxConfigList, 'ready', 'error'];

//微信sdk方法注册微信事件
syncApiList.forEach((key: string) =>
  Object.defineProperty(wxPromisify, key, {
    enumerable: true,
    configurable: false,
    writable: false,
    value: WX[key],
  })
);

//自定义方法
const asyncApiList: any = {
  //wx.config
  async config() {
    const url: string = window.location.href.split('#')[0]; //链接
    const resAuth: any = await API.userApi.getAuthority({ url }); //请求wx.config参数

    wx.config({
      appId: resAuth.appId, // 必填，公众号的唯一标识
      timestamp: resAuth.timestamp, // 必填，生成签名的时间戳
      nonceStr: resAuth.noncestr, // 必填，生成签名的随机串
      signature: resAuth.signature, // 必填，签名
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      jsApiList: wxConfigList,
      openTagList: ['wx-open-launch-weapp'],
    });
    _wxReadyPromisify = new Promise((resolve: any, reject: any) => {
      wx.ready(resolve);
      wx.error(reject);
    });

    return _wxReadyPromisify;
  },

  //检查ready是否已通过config
  async checkReady() {
    if (!_wxReadyPromisify) await asyncApiList.config();
    return (
      _wxReadyPromisify || Promise.reject(new Error('wx:请先初始化js-sdk'))
    );
  },

  //设置分享
  setShareData(data: any) {
    return Promise.all([
      this.setTimelineShareData(data),
      this.setAppMessageShareData(data),
    ]);
  },

  // 自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容
  setTimelineShareData(data: any) {
    return this.checkReady().then(() => {
      return new Promise((resolve) =>
        wx.updateTimelineShareData({ ...data, success: resolve })
      );
    });
  },

  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  setAppMessageShareData(data: any) {
    return this.checkReady().then(() => {
      return new Promise((resolve) =>
        wx.updateAppMessageShareData({ ...data, success: resolve })
      );
    });
  },

  //隐藏右上角分享菜单
  hideMenuItem() {
    return this.checkReady().then(() => {
      wx.hideAllNonBaseMenuItem();
      wx.hideOptionMenu();
    });
  },

  //显示右上角分享菜单
  showMenuItem() {
    return this.checkReady().then(() => {
      wx.showAllNonBaseMenuItem();
      wx.showOptionMenu();
    });
  },
};

//微信自定义方法注册微信事件
Object.keys(asyncApiList).forEach((key: string) =>
  Object.defineProperty(wxPromisify, key, {
    enumerable: true,
    configurable: false,
    writable: false,
    value: asyncApiList[key],
  })
);
export default wxPromisify;
